import React, { useState, Fragment, useCallback } from 'react'
import { LoginRegisterForm } from './Form'
import { useLayoutHeader } from 'components/MainLayout'
import { getAuthApi } from 'api'
import './register.css'
import { Typography, Col, Row, message } from "antd";
import { useHistory } from 'react-router';
import routesConfig from 'routesConfig';
import momentJaalali from 'moment-jalaali'
import { fixNumbers } from 'utils';
import _ from 'lodash'

const { Title } = Typography;

const headerConfig = {
    pageTitle: "ثبت‌نام",
    closeable: true,
    menuEnabled: false,
    extra: [],
}

export const LoginRegisterFormContainer = (props) => {
    const { onRegisterSuccess } = props
    const [{ loading, submitting, failed, nid }, setState] = useState({ loading: false, submitting: false, failed: false, nid: "INVALID" })

    useLayoutHeader(headerConfig)
    const onFinish = useCallback(({ firstName, lastName, nationalId, email, gender, birthDate, nidOtp }) => {
        if (nid !== "VALIDATED") {
            switch (nid) {
                case "INVALID":
                    return message.warn("کد ملی باید با شماره موبایل شما مطابقت داشته باشد", 5)
                case "VERIFY_FAILED":
                    return message.warn("خطا در تایید کد ملی، لطفا مطمئن شوید کد ملی با شماره موبایل شما مطابقت دارد", 5)
                default:
                    return message.warn("تایید کد ملی به درستی انجام نشد, دوباره تلاش کنید", 5)
            }
        }
        setState({ submitting: true })
        const registrationData = {
            firstName,
            lastName,
            nationalId,
            birthDate: birthDate !== undefined && birthDate !== null ? momentJaalali(birthDate.value, 'jYYYY/jM/jD').add(1, 'day') : undefined,
            email,
            gender,
            nidOtp
        }

        // console.log("registration")
        // console.log(registrationData)

        getAuthApi().registerUser(registrationData)
            .then(res => {
                onRegisterSuccess && onRegisterSuccess(res)
            })
            .catch(error => {
                // console.log("error")
                // console.log(error)
                setState({ submitting: false, failed: true })
            })

    }, [loading, submitting, failed, nid])

    const onChange = (fields) => {
        let nstate = {}
        if (fields) {
            const f = fields.find(f => f.name[0] == "nationalId")
            if (f && ["OTP_FAILED", "VERIFY_FAILED", "INVALID"].includes(nid)) {
                if (f.errors.length > 0) {
                    nstate = { ...nstate, nid: "INVALID" }
                } else {
                    nstate = { ...nstate, nid: "READY" }
                }
            }
        }
        if (failed) {
            nstate = { ...nstate, failed: false }
        }
        if (!_.isEmpty(nstate)) {
            setState(nstate)
        }
    }

    const onNidRequestValidation = (nationalId) => {
        setState({ nid: "OTP_WAITING" })
        getAuthApi().requestNationalIdOtp({ nationalId: fixNumbers(nationalId) })
            .then(() => setState({ nid: "OTP_SENT" }))
            .catch(() => setState({ nid: "OTP_FAILED" }))
    }

    const onNidVerifyRequest = (otp) => {
        setState({ nid: "VERIFY_WAITING" })
        getAuthApi().verifyNationalIdOtp({ otp })
            .then(() => setState({ nid: "VALIDATED" }))
            .catch(() => setState({ nid: "VERIFY_FAILED" }))

    }
    const history = useHistory()
    const onCancel = () => {
        history.push(routesConfig.home)
    }
    return <Fragment>
        <Row>
            <Col span={24} className='px-40'>
                <Title level={2} className='f-30 mb-1'> ثبت‌نام </Title>
                <p className='color-primary f-14 mb-36'>لطفا اطلاعات زیر را به صورت صحیح وارد کنید</p>
            </Col>
            <Col span={24} className='px-40'>
                <LoginRegisterForm loading={loading}
                    submitting={submitting}
                    failed={failed}
                    onFinish={onFinish}
                    onChange={onChange}
                    onCancel={onCancel}
                    onNidValidationRequest={onNidRequestValidation}
                    onNidVerifyRequest={onNidVerifyRequest}
                    nidState={nid}
                />
            </Col>
        </Row>
    </Fragment>
}
